import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  layoutsSql: [],
  layoutsSqlSelected: [],
  layoutsSqlUsuarios: []
};

const getters = {
  // Projeto
  layoutsSql: state => state.layoutsSql,
  layoutsSqlUsuarios: state => state.layoutsSqlUsuarios,
  layoutsSqlSelected: state => state.layoutsSqlSelected
}

const actions = {
  async fetchLayoutsSql({ commit }, args) {
    let response = null;
    if (args && args.idRecursoSistema) {
      response = await axios.get(`${baseUrl}/layoutssql?idRecursoSistema=${args.idRecursoSistema}`);
    } else {
      response = await axios.get(`${baseUrl}/layoutssql`);
    }
    if (response.data.length) {
      const data = response.data.filter(sql => sql.Status.includes(args && args.status || 'A'));
      commit('setLayoutsSql', data);
    } else {
      commit('setLayoutsSql', []);
    }
  },
  async fetchLayoutsSqlUsuario({ commit }, args) {
    const response = await axios.get(`${baseUrl}/layoutssql/${args.usuario.IdUsuario}?idRecursoSistema=${args.idRecursoSistema}`);
    if (response.data.length) {
      const data = response.data.filter(sql => sql.Status.includes(args && args.status || 'A'));
      commit('setLayoutsSql', data);
    } else {
      commit('setLayoutsSql', []);
    }
  },
  async fetchLayoutSqlById({ commit }, id) {
    const response = await axios.get(`${baseUrl}/layoutssql/${id}`);

    if (response.data.length) {
      commit('setLayoutsSql', response.data);
      return response.data[0];
    } else {
      commit('setLayoutsSql', []);
    }
  },
  async addLayoutSql({ commit }, layoutSql) {
    const response = await axios.post(`${baseUrl}/layoutssql`, layoutSql, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    layoutSql.IdLayoutSql = response.data.IdLayoutSql;
    commit('newSql', layoutSql);
    // return response.data.IdLayoutSql;
    return layoutSql;
  },
  async updateLayoutSql({ commit }, updLayoutSql) {
    await axios.put(`${baseUrl}/layoutssql`, updLayoutSql, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateLayoutSql', updLayoutSql);
  },
  async deleteLayoutSql({ commit }, id) {
    await axios.delete(`${baseUrl}/layoutssql/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeLayoutSql', id);
  },
  async selectLayoutsSql({ commit }, layoutsSql) {
    commit('newLayoutSqlSelected', layoutsSql);
  },
  async resetLayoutsSqlSelected({ commit }) {
    commit('resetLayoutsSqlSelected');
  },
  // Layout Sql Usuarios
  async fetchLayoutsSqlUsuarios({ commit }, idLayoutSql) {
    const response = await axios.get(`${baseUrl}/layoutssqlusuario/${idLayoutSql}`);
    if (response.data.length) {
      commit('setLayoutsSqlUsuarios', response.data);
    } else {
      commit('setLayoutsSqlUsuarios', []);
    }
  },
  async addLayoutSqlUsuario({ commit }, usuario) {
    try {
      const response = await axios.post(`${baseUrl}/layoutssqlusuario`, usuario);
      if (response) {
        commit('newLayoutSqlUsuario', usuario);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async updateLayoutSqlUsuario({}, layoutSqlUsuario) {
    await axios.put(`${baseUrl}/layoutssqlusuario`, layoutSqlUsuario);
  },
  async deleteLayoutSqlUsuario({ commit }, usuario) {
    await axios.delete(`${baseUrl}/layoutssqlusuario/${usuario.IdUsuario}/${usuario.IdLayoutSql}`);
    commit('removeLayoutSqlUsuario', usuario.IdUsuario);
  },
  resetaLayoutSqlUsuarios({ commit }) {
    commit('resetaLayoutSqlUsuarios');
  }
}

const mutations = {
  // Layout Sql
  setLayoutsSql: (state, layoutsSql) => state.layoutsSql = layoutsSql,
  newSql: (state, sql) => state.layoutsSql.push(sql),
  removeLayoutSql: (state, id) => state.layoutsSql = state.layoutsSql.filter(layoutSql => layoutSql.IdLayoutSql !== id),
  updateLayoutSql: (state, updLayoutSql) => {
    const index = state.layoutsSql.findIndex(layoutSql => layoutSql.IdLayoutSql === updLayoutSql.IdLayoutSql);
    if (index !== -1) {
      state.layoutsSql.splice(index, 1, updLayoutSql);
    }
  },
  newLayoutSqlSelected: (state, layoutsSql) => state.layoutsSqlSelected = layoutsSql,
  resetLayoutsSqlSelected: state => state.layoutsSqlSelected = [],
  // Layout Sql Usuario
  setLayoutsSqlUsuarios: (state, layoutsSqlUsuarios) => state.layoutsSqlUsuarios = layoutsSqlUsuarios,
  newLayoutSqlUsuario: (state, usuario) => state.layoutsSqlUsuarios.push(usuario),
  removeLayoutSqlUsuario: (state, id) => state.layoutsSqlUsuarios = state.layoutsSqlUsuarios.filter(usuario => usuario.IdUsuario !== id),
  resetaLayoutSqlUsuarios: state => state.layoutsSqlUsuarios = []
}

export default {
  state,
  getters,
  actions,
  mutations
}